import { IApplicationState } from '../../types/redux';
import { IServicePageInfo } from '../../types/servicePageInfo';

export function selectServicePageInfo(state: IApplicationState): IServicePageInfo {
  const {
    legalCheck: { currentStep },
    payment: { paymentStatus },
  } = state;

  return {
    currentStep,
    paymentStatus,
  };
}
